<template>
  <section class="mod-right-info">
    <profile class="avatar-info"
             v-if="detail.publisher.name"
             :id="detail.publisher.accountId"
             :name="detail.publisher.name"
             :medal="detail.publisher.medal"
             :image="detail.publisher.headImage"
             :nio-icon="detail.publisher.showNioIcon"
             inline
             size="small"></profile>
    <section class="mod-right-info__sessions-wrap">
      <start-layout class="mod-right-info__session-title" :sub-content="$t('content.titleSelectDateTime')"
                    :icon="icons.timeIcon"></start-layout>
      <sessions :list="detail.scenes" @change="handleChangeScene"></sessions>
    </section>
    <start-layout :content="detail.place.name"
                  :sub-content="detail.place.address"
                  :icon="icons.nav"></start-layout>
    <div class="mod-right-info__map-wrap">
      <gmap-map
        :center="{lat:detail.place.location.lat, lng:detail.place.location.lon}"
        :zoom="7"
        map-type-id="terrain"
        style="width: 100%; height: 100%">
      </gmap-map>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import Profile from '@/components/common/Profile';
import Sessions from '@/components/web_activity/Sessions';
import StartLayout from '@/components/web_activity/StartLayout';

import {supreme} from '@/supreme-core';
import {CACHE_KEYS} from '@/assets/js/constant';
import util from '@/util/util';

import nav from '@/assets/images/activity/location.png';
import timeIcon from '@/assets/images/activity/time.png'

Vue.use(VueGoogleMaps, {
  load: {
    key: util.getEnvInfo().googleMapKey,
    libraries: 'places'
  }
});

export default {
  name: 'RightInfo',
  components: {
    Profile,
    Sessions,
    StartLayout
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      icons: {
        nav,
        timeIcon
      }
    };
  },
  methods: {
    handleChangeScene(index){
      supreme.localCache.set(CACHE_KEYS.SELECTED_SCENE, index);
      this.$emit('change-scene', this.detail.scenes[index], index);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/standard';
  @import '@/assets/scss/mixins';
  .mod-right-info {
    &__sessions-wrap {
      padding-bottom: sizeTrans(35);
    }

    &__sub-title {
      margin-bottom: sizeTrans($space_20);
      @include title_m();
    }

    &__session-title {
      margin-bottom: sizeTrans($space_20);
    }

    &__map-wrap {
      width: calcPcVw(375);
      max-width: sizeTrans(375);
      height: calcPcVw(379);
      max-height: sizeTrans(379);
      margin-top: sizeTrans(20);
    }

    .avatar-info.common-profile.small {
      margin-bottom: sizeTrans(30);
      ::v-deep .common-profile__avatar-wrap {
        width: sizeTrans(32);
        height: sizeTrans(32);
        min-width: sizeTrans(32);
        max-width: sizeTrans(32);
      }
      ::v-deep .common-profile__name {
        font-size: sizeTrans(14);
        line-height: sizeTrans(23);
      }
    }

    &__map-wrap {
      width: 100%;
      height: calcVw(203);
    }

    @include touch {
      &__sessions-wrap {
        padding-bottom: sizeTrans(5);
      }

      .avatar-info.common-profile.small {
        margin-bottom: sizeTrans(30);
        ::v-deep .common-profile__avatar-wrap {
          width: sizeTrans(23);
          height: sizeTrans(23);
          min-width: sizeTrans(23);
          max-width: sizeTrans(23);
        }
      }
    }
  }
</style>